import { Pipe, PipeTransform } from '@angular/core';
import {
  CheckCategoryEnum,
  CheckCategoryInfo,
} from '@qaroni-app/check/types/check-category.enum';

@Pipe({
  name: 'checkCategoryName',
  standalone: false,
})
export class CheckCategoryNamePipe implements PipeTransform {
  transform(value: CheckCategoryEnum): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(CheckCategoryInfo, value)
    ) {
      return CheckCategoryInfo[value].name;
    }

    return value;
  }
}
